export default __webpack_public_path__ + "static/media/selectedLanguage.8d6cbf8a.svg";